export default {
  displayName: 'Name des Beladeplans',
  description: 'Beschreibung des Beladeplans',
  partIds: 'Teile',
  assetIds: 'Anlagen',
};
